import React, { useCallback } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./context/LanguageContext";
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import KurumsalSection from "./components/KurumsalSection";
import HizmetlerSection from "./components/HizmetlerSection";
import GrupFaaliyetSection from "./components/GrupFaaliyetSection";
import InovasyonSection from "./components/InovasyonSection";
import GaleriSection from "./components/GaleriSection";
import HaberlerSection from "./components/HaberlerSection";
import IletisimSection from "./components/IletisimSection";
import Footer from "./components/Footer";

const Home = () => {
  const scrollToSection = useCallback((sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerOffset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header scrollToSection={scrollToSection} />
      <main>
        <HeroSection scrollToSection={scrollToSection} />
        <KurumsalSection />
        <HizmetlerSection scrollToSection={scrollToSection} />
        <GrupFaaliyetSection />
        <InovasyonSection />
        <GaleriSection />
        <HaberlerSection />
        <IletisimSection />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </LanguageProvider>
    </div>
  );
}

export default App;
